module.exports = __webpack_public_path__ + "static/media/demo_2.a6cce4bb.png";